import { render, staticRenderFns } from "./UpdatePhoto.vue?vue&type=template&id=4252c1b6&"
import script from "./UpdatePhoto.vue?vue&type=script&lang=js&"
export * from "./UpdatePhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports